//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import headerBackTitle from '@/components/header/headerBackTitle'
	import publishTop from '@/components/donateTogether/publishTop'
	// import publishItem from '@/components/donateTogether/publishItem'
	export default {
		name: 'dTPublish',
		components: {
			publishTop,
			// publishItem,
			headerBackTitle
		},
		data() {
			return {
				publishSuccess: false,
				dtId: '',
				acr001: this.$route.params.acr001,
				epId: this.$route.params.epId,
				shareInfo:{},
				details:'',
				isshareGuide:false,
				listArr:[{
					name:'目标金额/元',
					value:this.G("goalMoney")
				},{
					name:'截止日期',
					value:this.G("deadlineDate")
				}]
			}
		},
		filters: {
			dateSwitch: function(value) {
				return value.replace(/[-]/g,'.')
			}
		},
		created() {
			if(this.G("goalMoney")>=1000000){
				let divide = this.G("goalMoney")/10000
				this.listArr[0].name = '目标金额/万元'
				this.listArr[0].value = divide.toFixed(3).slice(0,-1)
			}
		},
		methods: {
			shareDetail(){
				if(this.isWeixinCient()){
		         	this.isshareGuide = true

		   		}else{

					var u = navigator.userAgent
					let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
					if(isiOS){
						window.share.getShareDetailView(this.shareInfo);
					}else{
						window.android.getShareDetailView(this.shareInfo);
					}
        			// window.share.getShareDetailView(this.shareInfo);
		   		}
			},
			publishTopData(data) {
				this.details = data
			},
			wechatshareneedkey() {
	   		if(this.isWeixinCient()){
	   			let lineLink = window.location.href.split('#')[0];//要分享页面的地址，即该页面地址
	   			let companyName = this.G("companyName")
	   			this.shareInfo = {
			        title : '社会帮扶，让爱在阳光下连接~',
			        desc: '我们代表'+companyName+'，向「'+this.details.title+'」项目发起一起捐，你也快来参加吧~',
			        link : this.appjump_url+'/pages/index/#/dTDetail/'+this.dtId+'/'+this.acr001+'/'+this.epId+'/share',
			        imgUrl: this.details.acr065
			    };
			    this.setWeixinConfig(this.shareInfo);
	   		}else{
	   			let companyName = this.G("companyName")
	   			let title = '社会帮扶，让爱在阳光下连接~'
	   			let desc = '我们代表'+companyName+'，向「'+this.details.title+'」项目发起一起捐，你也快来参加吧~'
	   			console.log('{"picurl":"'+this.details.acr065+'","title":"'+title+'","type":"'+2+'","projectId":"'+this.acr001+'","text":"'+desc+'","url":"'+this.appjump_url+'/pages/index/#/dTDetail/'+this.dtId+'/'+this.acr001+'/'+this.epId+'/share","ischange":'+'"2"'+'}','eeeeeeeeeeeeeeeeeeeeee')
	   			this.shareInfo = '{"picurl":"'+this.details.acr065+'","title":"'+title+'","type":"'+2+'","projectId":"'+this.acr001+'","text":"'+desc+'","url":"'+this.appjump_url+'/pages/index/#/dTDetail/'+this.dtId+'/'+this.acr001+'/'+this.epId+'/share","ischange":'+'"2"'+'}'
	   		}
			},
			backEdit() {
				this.$router.replace('/dTEdit/'+this.acr001+'/'+this.epId)
			},
			finishPublish() {
				let data = {
			        crowdfundingId: this.acr001,
			        creatorName: this.G("companyName"),
			        creatorId: this.epId,
			        groupdonationTitle: this.G("itemTitle"),
			        groupdonationDetail: this.G("itemDescription"),
			        endTime: this.G("deadlineDate"),
			        targetNum: this.G("goalMoney")
			      }
		        this.$https.post(this.BASE_URL+"grd/groupDonation/create",
		          data
		        )
		        .then(res => {
		        	if(res.data.code == 'GRD-APII0000') {
								this.publishSuccess = !this.publishSuccess
								this.dtId = res.data.data
								this.wechatshareneedkey()
		        	}else {
		            this.showToast('','text','一起捐发起失败','20em','','')
		        	}

		        })
		        .catch(function(err) {
		        	console.log(err);
		        })
			},
			clsoeAlert() {
				// 发起成功后关闭弹框
				this.publishSuccess = !this.publishSuccess
				if(this.isWeixinCient()){
	    			this.$router.push('/zcprojectDetail/'+this.acr001+'/'+this.G("zcuserid")+'/'+this.G("zcnickname")+'/null')
		    	}else{
		    		this.$router.push('/zcprojectDetail/'+this.acr001+'/'+this.G("zcuserid")+'/'+this.G("zcnickname")+'/'+this.G("zctoken")+"?histroy=black"+'?headImage='+this.G('zcheadimgurl'))
		    	}
				// this.$router.push('/dTDetail/'+this.dtId+'/'+this.acr001+'/'+this.epId+'/false')
			}
		},
		beforeRouteLeave (to, from, next) {
	    if (to.name == 'dTEdit') {
	      to.meta.isUseCache = true
	    }
	    next();
		}
	}



// WEBPACK FOOTER //
// ./src/crowd_fund/dTPublish.vue